export const GET_PUB_KEY = 'stripe/GET_PUB_KEY';
export const SET_PUB_KEY = 'stripe/GET_PUB_KEY';
export const GET_CLIENT_SECRET = 'stripe/GET_CLIENT_SECRET';
export const SET_CLIENT_SECRET = 'stripe/SET_CLIENT_SECRET';
export const RESET_CLIENT_SECRET = 'stripe/RESET_CLIENT_SECRET';
export const RESET_SETUP_INTENT = 'stripe/RESET_SETUP_INTENT';
export const RESET_STRIPE = 'stripe/RESET_STRIPE';
export const STRIPE_SYNCHRONIZE = 'stripe/RESET_STRIPE';
